var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 80,
    viewBox: "0 0 98 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 12.4946C83.3218 19.436 75.9828 27.5921 75.9828 36.9631C82.2391 37.6573 87.4125 40.1157 91.5031 44.3384C95.5938 48.5611 97.6391 53.449 97.6391 59.0022C97.6391 64.9024 95.6539 69.8771 91.6836 73.9263C87.7133 77.9754 82.7203 80 76.7047 80C69.9672 80 64.1321 77.3681 59.1992 72.1041C54.2664 66.8402 51.8 60.4483 51.8 52.9284C51.8 30.3687 64.9139 12.726 91.1422 0L98 12.4946ZM46.2 12.4946C31.4015 19.436 24.0023 27.5921 24.0023 36.9631C30.3789 37.6573 35.6125 40.1157 39.7031 44.3384C43.7938 48.5611 45.8391 53.449 45.8391 59.0022C45.8391 64.9024 43.8238 69.8771 39.7934 73.9263C35.7629 77.9754 30.7399 80 24.7242 80C17.9867 80 12.1817 77.3681 7.30898 72.1041C2.4363 66.8402 0 60.4483 0 52.9284C0 30.3687 13.0538 12.726 39.1617 0L46.2 12.4946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.eb3455a86be0892f5328576592042bd9.svg";
export { ForwardRef as ReactComponent };